(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-comments"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('igc-comments')) {
    customElements.define(
      'igc-comments',
      class extends HTMLElement {
        connectedCallback() {
          if (this.pronto) return;

          // O parser faz o upgrade do elemento na tag de ABERTURA, antes de ler os
          // filhos. Numa segunda instancia da secao na mesma pagina isso acontecia e
          // o connectedCallback saia aqui para sempre -- nada era ligado nela: nem o
          // "Ver mais", nem as setas, nem o resize. Medido: this.list ficava nulo com
          // o [data-igc-list] presente no DOM.
          this.list = this.querySelector('[data-igc-list]');
          if (!this.list) {
            if (document.readyState === 'loading') {
              document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true });
            }
            return;
          }
          this.pronto = true;

          this.setupReadMore();
          this.setupCarousel();
          this.setupDots();

          let timer;
          this.onResize = () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
              this.checkOverflow();
              this.updateArrows();
              this.updateDots();
            }, 150);
          };
          window.addEventListener('resize', this.onResize);

          // Ultima palavra depois que imagens e fontes entram.
          this.onLoad = () => {
            this.checkOverflow();
            this.updateArrows();
            this.updateDots();
          };
          window.addEventListener('load', this.onLoad, { once: true });
          if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => this.checkOverflow());
          }
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.onResize);
          if (this.onLoad) window.removeEventListener('load', this.onLoad);
        }

        setupReadMore() {
          this.addEventListener('click', (event) => {
            const button = event.target.closest('[data-igc-more]');
            if (!button) return;
            const text = button.previousElementSibling;
            const open = text.classList.toggle('is-open');
            button.setAttribute('aria-expanded', String(open));
            button.textContent = open ? this.dataset.less : this.dataset.more;
          });
          // Um frame so nao basta no carrossel: os itens sao flex dentro de um
          // scroller e a largura final so existe depois do layout. Medido a 390px,
          // um comentario com 288px de texto num box de 96px nao ganhava o botao.
          requestAnimationFrame(() => requestAnimationFrame(() => this.checkOverflow()));
        }

        checkOverflow() {
          this.querySelectorAll('[data-igc-text]').forEach((text) => {
            const button = text.nextElementSibling;
            if (!button || text.classList.contains('is-open')) return;
            button.hidden = text.scrollHeight <= text.clientHeight + 1;
          });
        }

        setupCarousel() {
          this.prev = this.querySelector('[data-igc-prev]');
          this.next = this.querySelector('[data-igc-next]');
          if (!this.prev || !this.next) return;

          const step = (direction) => {
            const item = this.list.querySelector('.igc__item');
            const gap = parseFloat(getComputedStyle(this.list).columnGap) || 12;
            const distance = item ? item.getBoundingClientRect().width + gap : this.list.clientWidth;
            this.list.scrollBy({ left: direction * distance });
          };
          this.prev.addEventListener('click', () => step(-1));
          this.next.addEventListener('click', () => step(1));
          this.list.addEventListener('scroll', () => this.updateArrows(), { passive: true });
          this.updateArrows();
        }

        updateArrows() {
          if (!this.prev || !this.next) return;
          const max = this.list.scrollWidth - this.list.clientWidth - 2;
          this.prev.disabled = this.list.scrollLeft <= 2;
          this.next.disabled = this.list.scrollLeft >= max;
        }

        // Um cartao por vez ocupa quase a tela inteira no celular, onde as setas
        // nao aparecem: sem os pontos nao da para saber quantos comentarios existem.
        passoDoCarrossel() {
          const item = this.list.querySelector('.igc__item');
          if (!item) return 0;
          const gap = parseFloat(getComputedStyle(this.list).columnGap) || 12;
          return item.getBoundingClientRect().width + gap;
        }

        setupDots() {
          this.dots = Array.from(this.querySelectorAll('[data-igc-dot]'));
          if (!this.dots.length) return;
          this.dots.forEach((dot, i) => {
            dot.addEventListener('click', () => {
              const passo = this.passoDoCarrossel();
              if (passo) this.list.scrollTo({ left: i * passo });
            });
          });
          this.list.addEventListener('scroll', () => this.updateDots(), { passive: true });
          this.updateDots();
        }

        updateDots() {
          if (!this.dots || !this.dots.length) return;
          const passo = this.passoDoCarrossel();
          if (!passo) return;
          const atual = Math.min(this.dots.length - 1, Math.max(0, Math.round(this.list.scrollLeft / passo)));
          this.dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === atual);
            if (i === atual) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
